import { SignedUrlResponse } from 'api/fetchers/postSignedUrl'

export const fileUpload = async (signedUrl: SignedUrlResponse, file: File) => {
  try {
    const formDataAPI = new FormData()
    // const files = filesToUpload.map(file => new Blob([file]))
    const fileBlob = new Blob([file], { type: signedUrl.fileObject.type })
    Object.entries(signedUrl.signedUrlObj.fields).forEach(([key, value]) => {
      formDataAPI.append(key, value as string)
    })

    formDataAPI.append('file', fileBlob, signedUrl.fileObject.name)
    // await uploadFile({ uploadUrl: fileUrl.signed_url, formData: formDataAPI })
    await fetch(signedUrl.signedUrlObj.url, {
      headers: {
        //'Content-Type': signedUrl.fileObject.type,
        //...signedUrl.signedUrlObj.fields,
      },
      body: formDataAPI,
      method: 'post',
    })
  } catch (e) {
    console.error('Error uploading file, please try again later', e)
  }
}
